// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // URL absoluta da API dev — CORS já libera origem cemonitor.dev.redesampa.com
  // e localhost:8100 (CE-Monitor-Queue/config/env.js devDb._corsOptions).
  // O /api-proxy só funcionava com ng serve + proxy.conf.json e quebrava no
  // build deployado (Apache devolvia index.html no fallback de SPA).
  arboUrl: 'https://api.cemonitor.dev.redesampa.com',
  title: 'Influlens',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
